<template>
  <div>
    <el-container direction="vertical">
      <el-row>
        <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%">
          <el-table-column width="100px" align="center" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.patientName }}</span>
            </template>
          </el-table-column>
          <el-table-column width="115px" align="center" label="联系方式">
            <template slot-scope="scope">
              <span>{{ scope.row.phone || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="type" label="随访类型" />

          <el-table-column min-width="248px" align="center" label="项目">
            <template slot-scope="scope">
              <span>{{ scope.row?.examReportInfo?.reportName || "-" }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="time" width="150px" label="复查到期时间" />

          <el-table-column prop="status" label="状态" />

          <el-table-column width="150px" align="center" label="随访时间">
            <template slot-scope="scope">
              <span>{{ getParsedTime(scope.row.startTime) }}</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" align="center" label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="handleView(scope.$index, scope.row)">查看随访详情</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :total="total" :page.sync="formData.pageNum" :limit.sync="formData.pageSize"
          @pagination="turnToPage" />
      </el-row>
    </el-container>
  </div>
</template>

<script>
import {
  getListByTime,
} from "@/api/health/Patients.js"
import Pagination from "@/components/Pagination";
import imageLine from "@/assets/images/titleLine.png";
import moment from "moment";

export default {
  components: { Pagination },
  props: {
    pInfo: null
  },
  data() {
    return {
      open: false,
      linkLine: imageLine,
      form: {
        patientName: null,
        status: null,
        idcard: null,
        type: null,
        serviceName: '肺结节随访',
        // followupFlag: "1",
      },
      formData: {
        pageNum: 1,
        pageSize: 10
      },
      listLoading: false,
      total: 0,
      list: []
    };
  },
  watch: {},
  created() {
    this.getList(this.pInfo);
  },
  methods: {
    setOpen(bool) {
      this.open = bool;
    },
    getList(row = {}) {
      this.list = [];
      this.listLoading = true;

      getListByTime({ ...this.form, idcard: row.idcard }).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.total = res.data.total;
          this.list = res.data.records;
          this.list.sort(function (a, b) {
            return b.createDate < a.createDate ? -1 : 1;
          });
        }
      }).catch(error => {
        console.log(error);
        this.listLoading = false;
      });
    },
    // 导航跳转查询列表页
    turnToPage() {
      let params = Object.assign({}, this.listQuery, this.formData)
      this.listLoading = true;
      turnToListByTime({ ...params, idcard: row.idcard }).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.list = res.data.records;
          this.list.sort(function (a, b) {
            return b.createDate < a.createDate ? -1 : 1;
          });
          this.total = res.data.total;
        }
      });
    },
    handleView(index, row) {
      console.warn("查看随访记录", index, row);
    },
    getParsedTime(time) {
      return moment(time).format("YYYY-MM-DD");
    },
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-table thead th {
  background-color: #f5f5f5 !important;
}
</style>
1
